import clsx from 'clsx'
import { formatMoney } from '../../../helpers/currency-formatter'

interface PriceProps {
  price: string
  compareAtPrice?: string
  className?: string
  isOutlet?: boolean
}

export function Price({ price, compareAtPrice, className, isOutlet }: PriceProps) {
  const isOnSale = parseFloat(price) < parseFloat(compareAtPrice || '0')
  const moneyFormat = window.globals?.shopify?.moneyFormat || '${{amount}}'

  const formatPrice = (value: string) => {
    if (!value) return ''

    const priceInCents = Math.round(parseFloat(value) * 100)

    return formatMoney(priceInCents, moneyFormat)
  }
  const isOutletSale = isOnSale && isOutlet

  return (
    <p className={clsx(className)}>
      <span className={clsx('paragraph-xs lg:paragraph-s', isOutletSale ? 'text-brand-sale font-medium' : isOnSale ? 'text-type-black-primary font-medium' : 'text-type-black-primary font-medium')}>
        {formatPrice(price)}
      </span>
      {isOnSale || isOutletSale ? (
        <span className="line-through paragraph-xs lg:paragraph-s text-type-black-tertiary">
          {formatPrice(compareAtPrice || '')}
        </span>
      ) : null}
    </p>
  )
}
